import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {PageTransactionDTO} from '../model/pageTransactionDTO';
import {AssignSubcategoryDTO} from '../model/assignSubcategoryDTO';
import {TransactionSpanDTO} from '../model/transactionSpanDTO';
import {ManualImportDTO} from '../model/manualImportDTO';
import {FileUploadResponseDTO} from '../model/fileUploadResponseDTO';
import {ReportService} from './report.service';
import {ReportTypeCode} from '../model/reportTypeCode';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'transaction';

  constructor(private http: HttpClient) {
  }

  getUnassigned(accountId, pageNumber, pageSize, sortColumn, sortDirection, search) {
    const params = new HttpParams().append('page', pageNumber)
      .append('size', pageSize)
      .append('sort', `${sortColumn},${sortDirection}`);

    return this.http.get<PageTransactionDTO>(`${this.path}/${accountId}/unassigned?search=${search}`, {params: params});
  }

  getAssigned(accountId, pageNumber, pageSize, sortColumn, sortDirection, search) {
    const params = new HttpParams().append('page', pageNumber)
      .append('size', pageSize)
      .append('sort', `${sortColumn},${sortDirection}`);
    return this.http.get<PageTransactionDTO>(`${this.path}/${accountId}/assigned?search=${search}`, {params: params});
  }

  assignSubcategory(payments: AssignSubcategoryDTO) {
    return this.http.post<void>(`${this.path}/assign`, [payments]);
  }

  withdrawAssignment(id) {
    return this.http.get<void>(`${this.path}/withdraw-assignment/${id}`);
  }

  getOtherTransactions(reportType: ReportTypeCode, clientId, year, pageNumber, pageSize, sortColumn, sortDirection) {
    const params = new HttpParams().append('page', pageNumber)
      .append('size', pageSize)
      .append('sort', `${sortColumn},${sortDirection}`);
    return this.http.get<PageTransactionDTO>(`${this.path}/other/${reportType}/${clientId}?${ReportService.yearAppendix(year)}`, {params: params});
  }

  hasOtherTransactions(reportType: ReportTypeCode, clientId, year) {
    return this.http.get<boolean>(`${this.path}/has-other/${reportType}/${clientId}?${ReportService.yearAppendix(year)}`);
  }

  getTransactionSpans(reportType: ReportTypeCode, clientId, year) {
    return this.http.get<Array<TransactionSpanDTO>>(`${this.path}/span/${reportType}/${clientId}?${ReportService.yearAppendix(year)}`);
  }

  manualImport(dto: ManualImportDTO) {
    return this.http.post<FileUploadResponseDTO>(`${this.path}/manual-import`, dto);
  }
}
